import { useQuery } from '@apollo/client/react';
import { getInLifeQuotingFieldsData } from '@in-life/utils/getInLifeQuotingFieldsData';
import { getPersonEntityData } from '@in-life/utils/getPersonEntityData';
import { useEffect } from 'react';

import { ThankYouBasketFragment } from '@generated/gql/graphql';
import { thankYouQuery } from '@pages/ThankYou/query';
import {
  inLifeCoreServicesEntity,
  useTrackInLifeQuoteCompletedOnce,
} from '@tracking/trackingEvents';
import { completedBasketStorage } from '@utils/storagePropertyManagement';

type UseThankYouTrackingProps = {
  basketId: string;
  isReady: boolean;
};

const buildCoreServicesEntity = (basket: ThankYouBasketFragment) => {
  return {
    energy_selected: Boolean(basket.energy?.selectedQuote?.isSelected),
    broadband_selected: false,
    mobile_selected: false,
    insurance_selected: false,
  };
};

const useThankYouTracking = ({
  basketId,
  isReady,
}: UseThankYouTrackingProps) => {
  const trackOrderCompletedOnce = useTrackInLifeQuoteCompletedOnce();
  const { data } = useQuery(thankYouQuery, {
    variables: { basketId },
    skip: !basketId,
  });

  useEffect(() => {
    if (
      !isReady ||
      !basketId ||
      !data?.basket ||
      completedBasketStorage.isCompleted(basketId)
    ) {
      return;
    }

    trackOrderCompletedOnce(
      {},
      {
        contexts: [
          getInLifeQuotingFieldsData(),
          inLifeCoreServicesEntity(buildCoreServicesEntity(data.basket)),
          getPersonEntityData(),
        ],
      }
    );
    completedBasketStorage.setCompleted(basketId);
  }, [trackOrderCompletedOnce, basketId, isReady, data]);
};

export { useThankYouTracking };
